<template>
  <div class="f-creditsModal">
    <b-modal ref="creditsModal" id="creditsModal" title="Match Strategies Development Group for the #AlpFoodway Engagement Platform" size="lg" hide-footer>
      <b-row>
        <b-col v-for="(person, idx) in people" :key="idx" class="personal-card">
          <b-img rounded="circle" width="90" height="90" blank-color="#777" :alt="person.surname" class="m-1"
                 :src="person.picture"></b-img>
          <div><span class="name-style">{{person.name}}</span> <span class="surname-style">{{person.surname}}</span>
          </div>
          <p class="title-style">{{person.title}}</p>

          <b-row class="framed">
            <b-col class="button-style">
              <a :href="person.linkedinProfile" target="_blank">
                <div class="icon linkedin-icon mr-2"></div>
              </a>
            </b-col>
            <b-col class="button-style">
              <a :href="person.emailContact">
                <div class="icon email-icon mr-2"></div>
              </a>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <p class="adv-style">Visit our website:</p>
      <div>
        <a href="http://www.matchstrategies.com">
          <img src="../../assets/match_logo.png" class="logo-match" alt="Match Strategies"/>
        </a>
      </div>

      <a href="http://www.matchstrategies.com" class="site-style">www.matchstrategies.com</a>
    </b-modal>
  </div>
</template>

<script>
  export default {
    name: 'CreditsModal',
    data () {
      return {
        people: [
          {
            name: 'Calogero',
            surname: 'Amato',
            picture: 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBxAQEBAQEBAVEBAVDQ0NEBUVDRsQEA4RIB0iIiAdHxkaKDQsHiAxJxkZLTItMSotMC8vIys0OD8tNzQuLi0BCgoKDg0OFQ8QFS0ZFRkrKys3KysrNysrKys1Ky03Ny0rNy0rNy0rKystLTcrLSsrKy03Kys3LSstNy0rKysrLf/AABEIAMgAyAMBIgACEQEDEQH/xAAcAAEAAQUBAQAAAAAAAAAAAAAABQECAwQGBwj/xAA9EAACAQIEAwYEBAQEBwEAAAABAgADEQQFEiExQVEGImFxgbETMpGhByNC0VJicsEzgvDxFiRDY6Ky4RT/xAAZAQADAQEBAAAAAAAAAAAAAAAAAQIDBAX/xAAkEQEBAAICAgICAgMAAAAAAAAAAQIRAyESMUFRBCIyYRMUI//aAAwDAQACEQMRAD8A9vEQImVMiIiBERAEREARNXMMdSoUzUrOEQcSZ5p2o/EN6isuF1U6feHxLWqN5dJUlqscLk9AzjP8NhATXqhSATpHec/5ROHzT8WqS7UcOzHq7aR9BPKMZmL1GZmY7kkkm5Y9Sec0zc8+vGa48X208cJ/deq0Pxge/fwq6eemqdVvUToMo/FHBVmCVFfDk2AZrMl/McPpPCeAuN/7mVV9xY+fhKvFPgv1vw+rKNZXUMjBlIuCDcH1mSfNGRdpsVgmDUazKuoalO9Nh4qdp7b2M7Z0cwQKSExIW7078fFb8R7THLC4pyw13HVRESEEREQIiIjIiIAMREQBECJpSIiIgREQBMdaqqKzMQqgFmJNgB1mScH+K2cfDw4wyHv1bs2/BB+59o1YY+V04ntz2yfF1mSn/gI2mmCN2P8AEfHpOPNWoTctqJLbW68b+M3MtwTVX0qCSf7zrMs7LIljUOprDblLy5MeOarux4t+nn1XDuD3hbYW2l6YNyL6Tbje09ap5LRYC9MEDhN2nk1G1vhi2/KZ/wC7PoX8bv28fTKqhsQjG+4FpnXs/iLH8o7k8BwnstPA014IBwHyzIcP4D6SL+bfiHPx8Xjo7LV2BPwyANhcWv4zRoVK+CrLUQmm6OGU23B/blPaalIzmu1WUrVpsQO+LlTaPj/K8rrKHlwTXT0Dsh2hTMMMtVdnFkqr/A9vY8RJ2eIfhBmZo484dj3ayMhF/wBa7qf/AGHrPb5pnNV5+U1SIiSkiIiBEREZERAAiBEukRERAiIgCeP/AIgN8THVh/CqINr8h+89gnmXajAlsbVNjuyG42IFrQ3pvwXWVRfYbL7is1twosbSfWmZI9k8vFINt8xufWVzChocgcLzl5rvLbu4uTvxYsPTm/TozRpHxkhSfYTBee2VaENTEuVpja8tj216qD3kPmqd3hzk04kVmG4tFPbXGvK3cYbMqVS9guJp1DbpqE+j1N585ds8KVrK4859EYQ3pof5EP2no27xlef+RjrJmiIksCIiAIiJIIiIGCIES6RERECIiAJy/aDC3rauopidRIjO6lPUis4VydIF7M3lJz9L4/5MuX0QKewkXnbi/jaS+WGyWOxHjecZ2/XEsyrQso2JN7X8Jjcd9Ojiv7tzD1l6zdTEoLb9J5Li8BigfzMXTS+9jXIab2UpiKLa2qGpwK73B9ZV4JJvbo8rbrT1pGW00sdmiUV1NYCxveROQ5sMQhO4IJUg8QZpZ3SLk3F1XbfrMp71R/ju2lj/AMQKN9NNC3DjzmjiO01RtxQYrbvDgwmjmFd8GyaaC99S92F/YeHWTdLE1mdEq0x3qavcbgAi9jzBnRccZNyFh71tAdrEFehSrJ+p1Ubb78j6z2jKcVTamiK4ZlpIDY35ATzbPMsU4aogG1tY24Eb/vOl7NYZ/j0yG7op6StuQH99pOPJ1JC5uKZy5b9O0iImrziIiAIiIgRERGCIES6RERECIiADOAxWNrVMYy1BqooWq8NLUQvMN06gzv5xHbrDumt6f/VpFDbmVIP3F/pIznTt/B8bncbO76dHlbAioykFCyshHAqQDOU7TNUr6qatoF7E9JOdiVtgqI4n4asfC99vSaOYYbS56EmY5daquPGTkyn04nEdlEdqZU6ShN3vd38T47yex1FRTFlA0U1RSNnewsLnnJP4Q5C01syphabMeSmK8tupXRjhN7R/ZWjoVyTe9Q+pkjiV723A2BmPKMOwRGYW1DWPWbeNpaSCNj7yL/LbTKy1gTAKbXVXANxf9M2BhAN7AHwmXDgMoPA7TMUsL3hu1nZ2isyW6sORBX7SZ7LL3gQb/wDL0yftIPOammlUPRGP2nQdj07mr/tUhvxvaacc7jPmv/PJ0cRE6XmEREARERAiIiMEQIl0iIiIEREASI7TYH42HYAXZSKqddQ3kvBELNzSsMrhlMp8OJ7NYz4ZbUpQszVCpbVpufaTOaqrKWHnKZhkdMfFrID8QqD83d26CQOZ4lqdK53uCSec5ssbOq7fPHPPzx6bNJpqZ7TFSkyX03HEcRI7H5sUpa1G5RSvQkiczUzGs7MjuNRtsW4CGPFb26ccu4kVzjFUXUs6VqVgoXgy+I3+03sTnCPY1XKkWIUG1h42kPSyZaxUszOwYXWmNW3SST9mhtU+FU3Vg1yFDDymtxwO3v4icw2aUwo1Gw248pvLiFcGxBE4SrQJRkpLUchL+FrdfKbHZnEOr3JNvh2cEfKbbSLxTW5U5e0p2orflsgNi5CcOptPRcswQo0woNzYXNrXNp5fhKgxePwtJd0FYVWsb7L3v7feeuTXDHUm3F+RleoRESnKREQBERAEREkAiBEugiIiBERAEREAowvOGzuhdalM/MpI47Ecpk/E/tDVwmHUUWKO5ILL8w6AdLyLrCqMJh8QWLVRSCVu9e7DY+Zkck3qunhxs7+EE+JRcPuO8upAOPOwEvw9CjXQJVRWYAm5Aup85EY9AdWnfVfYek1MrxDo/O/ym4tpEvw66deOWq7DB0VpHZiovc2crvM1TH0D3S2o78STYyLpYpXA7wJ3J6W6ma9PADd72JICgtuCeH+vGZeO/bXLlTprIqHTtfcki1x4TjcwzP4VZtB2cb/TaSma4001CnhpPA/q3E480DVqlRbcncbgX5zbh453a5+XO7ep/hDlpIrYxhxZqFLble7EfYehnpU0smwSUMPRo010qlJFAHlv95ux29uDLLd2RESUkREAREQBERJpgiBEukRERAiIgCUZrbysjczxdu6PWLK6hybqB7WYJcSKZcXC1Ecf5WBEh8Upo069Bt1arVxNBv4kfcr5g3+06Cq9x5G8DBpXpmk/AG6Hmh8Jl7dOGcx6vp43Wxxo1KgZbqRbbY38Dym0GSohNI2uQLE2IPP/AFznRdoeyjBiGHG+lgNmnM/8OVkN1NrEMO7N5njXR477xq2nixTOm9jpOk268/GXnNzqUE7La1+g/wDvtMxyGq9tVunDjJDL+xtzckHhsReVc+Oe02ZOcxmLfEMqLcne20n+zGTDUCw1DUAx6tfeTYyNEsoAG+5C6TJOui0abNw0ozn0Eyz59zWImPzXoi8PpKyNyLG/FoUm5tSV/OSUqOC+yIiBEREAREQBEREARAiVQRERAlCbSlSoFFybCQ2ZZgTdF9YsstHMdtnGZmq7LuTtfxkPXqXJJ85qkFiPMXMy0RdR5FfoSJlu3221It1Tay+rZhfhwmm6ytLaBV0j01dSrAMp5GRGMyEDdBqHT9Q/eb2W1tQ34iSEVmxjncfTjHwgU8LeHSNxwM67EYRKo7w368xImvlZB7hDetjM7hW+PNL7QlOl3rneRHa3EEYeqq/O6mig6s206GtSKk6gRYXnOUMMcXjUAF6dG9U9C0rix3l2vPL9bXYYNWw+EwtuKU1U9CLSTw2cKfnGnxG6yEy9qz0FNV9WpFaxHynw8LTChKnSeE1tsrjkldklQMLqQR1BvLpyNOqyG6sR5GSeHzlv1rfxGxlef2m4JuJq4fH032DWPQ7GbUe9p1oiIjBEREFBKyg/aY69dUF2NveO9BlmnicwRTpBDMSBYHh5yNxua3uBt0F/eRgcnjt6TO5/TXHj+2xjMYzObkm2pR0mC+o3JsTaWOhPDfnK01I4yF9a6ZQNI6zDl7d034irXH/kZdUHOYED76DYEkkaQReMm2y7+ctC/XeWMX42BtvsdN5nTxuDsd/aNNZcK5Qgj18ZNpUBUEc5BmbmXVrHSeB4ecaUoovIHtXk+JxVNEw2I/8AzEPqqG5BcdO7vJ63+4lwPX6wl1Sc12moPRwakOXemiq7kd59tyfpMPYHCBKLl1IqufiNdbd08J0uPwy1ENNhcNa462N5dTQLeL5aef6eKDcW/LAICdwX/Vzv9/tNbEJcG3He0ksxWz+aj3miYJjGqbWMxU23KmbF7ceE18QLOD1tEpkmZMfUpWIJK7XBNxaYjKQG9unweKWouoeo6GbE5bJcT8OppJ2JC+h4fSdTNJdsrNERECauLr6QAOJH2kDiHudzN3Ft3yTyBEimBO995GV3W2M1A07b8pdpErTa+x4y/TEe1gWVtLhK2gnbAUubGZ1QAS11lgvwO4IIjDMg52v0/eLTTw9Q0yKTm4PdovzP8jePQ8/Obmq8PRAMDrAlTGE1haupQw8iPGZ1IkNgKtmtyPvJZTwP1iJo51gatcIlOsaJWtQqsQLllBuV9bCSNQbyiHvHyEyNHskRmo3U+DCR5knmy7Kf5j7SNtBShFxNfEDh6TYEw1hw8hEaqcPpEqkraAYHWzqfArOpy7E/EQE/MNmnL1ztfoQZv5ViNDi/AnSY4mzbpIiJSXOY9+8w/mM0l/ebGPbvt/U3vNXTzEj5bfC8ixv95fq6TGtTkdjLgsaauBlwlhlwiJcZRllRF4w16yK6lG4HxsR0IPIiY8DiDc0qh/NVQ1+ArU+AcexHI+Ym0yXmnjMMWsVOiqhLUm/hPQ9VPAiE+g3pdNbB4kVF1W0kEo6HjTccR+x6WmxaABJvB1NQB6jfzkJN7Kq1mKngdx5wJJrxmQiYmNvqJmgSNzUd0f1CRUmc0HcPmvvIciI1pEtccPITJaUqLw8hGayUPWVJlt+giC11uD5GFPPylz7XEwJ/tGHX4Orrpo3VRfziR+RYi4NM8Rdh5RKlRUVjf8R/6295iXwiJHy1XsAeImMqV3BuIiCV2u42lVqC9r7xEYXgS4ykRAEMt5SIw1alMo/xVF+6FqgfrXkf6h7bTcRuFtwQCCOBERAKkSqMQQRxBBERAJzUGW44FCZsgxESa0s2H5Z8195DGIjOEPufQREAsIlL23iIBgqvte2+yjxlEFgBEQDcy+toqKeVwD6xEQFf/9k=',
            title: 'Financial Strategist',
            linkedinProfile: 'https://www.linkedin.com/in/calogero-amato-341172120/',
            emailContact: 'mailto:calogero@matchstrategies.com'
          },
          {
            name: 'Andrea',
            surname: 'Vicari',
            picture: 'https://i.ibb.co/Rb4MjX5/0.jpg',
            title: 'Software Developer',
            linkedinProfile: 'https://www.linkedin.com/in/andrea-vicari/',
            emailContact: 'mailto:andrea.vicari@matchstrategies.com'
          },
          {
            name: 'Leonardo',
            surname: 'Iandiorio',
            title: 'Software Developer',
            picture: 'https://i.ibb.co/qgXVjGF/0-1.jpg',
            linkedinProfile: 'https://www.linkedin.com/in/leonardo-iandiorio/',
            emailContact: 'mailto:leonardo.iandiorio@matchstrategies.com'
          }
        ]
      }
    },
    methods: {
      showModal () {
        this.$refs.creditsModal.show()
      },
      hideModal () {
        this.$refs.creditsModal.hide()
      }
    },
    mounted () {
      document.getElementById('creditsModal___BV_modal_header_').setAttribute('style', 'background-color: #c41c21 !important; color: white !important;')
      document.getElementById('creditsModal___BV_modal_header_').lastChild.setAttribute('style', 'color: white !important;')
    }
  }
</script>

<style scoped>
  .personal-card {
    border: 1px solid #e1e8ed;
    overflow: hidden;
    cursor: pointer;
    background-color: #fff;
    border-radius: 4px;
    margin: 2%;
    padding: 3%;
    box-shadow: 10px 10px 8px #aaa;
  }

  .name-style {
    font-weight: bold;
    font-size: 16pt;
    color: grey;
  }

  .surname-style {
    font-weight: bold;
    font-size: 16pt;
    color: #c41c21;
  }

  .title-style {
    font-style: italic;
    font-size: 13pt;
  }

  .logo-match {
    width: 40%;
    margin: 0 auto;
  }

  .adv-style {
    margin: 0 auto;
    padding-top: 3%;
    font-weight: bold;
    font-size: 25pt;
    color: grey;
  }

  .email-icon {
    background: url("data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMS4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ4My4zIDQ4My4zIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0ODMuMyA0ODMuMzsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSIyNHB4IiBoZWlnaHQ9IjI0cHgiPgo8Zz4KCTxnPgoJCTxwYXRoIGQ9Ik00MjQuMyw1Ny43NUg1OS4xYy0zMi42LDAtNTkuMSwyNi41LTU5LjEsNTkuMXYyNDkuNmMwLDMyLjYsMjYuNSw1OS4xLDU5LjEsNTkuMWgzNjUuMWMzMi42LDAsNTkuMS0yNi41LDU5LjEtNTkuMSAgICB2LTI0OS41QzQ4My40LDg0LjM1LDQ1Ni45LDU3Ljc1LDQyNC4zLDU3Ljc1eiBNNDU2LjQsMzY2LjQ1YzAsMTcuNy0xNC40LDMyLjEtMzIuMSwzMi4xSDU5LjFjLTE3LjcsMC0zMi4xLTE0LjQtMzIuMS0zMi4xdi0yNDkuNSAgICBjMC0xNy43LDE0LjQtMzIuMSwzMi4xLTMyLjFoMzY1LjFjMTcuNywwLDMyLjEsMTQuNCwzMi4xLDMyLjF2MjQ5LjVINDU2LjR6IiBmaWxsPSIjRkZGRkZGIi8+CgkJPHBhdGggZD0iTTMwNC44LDIzOC41NWwxMTguMi0xMDZjNS41LTUsNi0xMy41LDEtMTkuMWMtNS01LjUtMTMuNS02LTE5LjEtMWwtMTYzLDE0Ni4zbC0zMS44LTI4LjRjLTAuMS0wLjEtMC4yLTAuMi0wLjItMC4zICAgIGMtMC43LTAuNy0xLjQtMS4zLTIuMi0xLjlMNzguMywxMTIuMzVjLTUuNi01LTE0LjEtNC41LTE5LjEsMS4xYy01LDUuNi00LjUsMTQuMSwxLjEsMTkuMWwxMTkuNiwxMDYuOUw2MC44LDM1MC45NSAgICBjLTUuNCw1LjEtNS43LDEzLjYtMC42LDE5LjFjMi43LDIuOCw2LjMsNC4zLDkuOSw0LjNjMy4zLDAsNi42LTEuMiw5LjItMy42bDEyMC45LTExMy4xbDMyLjgsMjkuM2MyLjYsMi4zLDUuOCwzLjQsOSwzLjQgICAgYzMuMiwwLDYuNS0xLjIsOS0zLjVsMzMuNy0zMC4ybDEyMC4yLDExNC4yYzIuNiwyLjUsNiwzLjcsOS4zLDMuN2MzLjYsMCw3LjEtMS40LDkuOC00LjJjNS4xLTUuNCw0LjktMTQtMC41LTE5LjFMMzA0LjgsMjM4LjU1eiIgZmlsbD0iI0ZGRkZGRiIvPgoJPC9nPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=");
  }

  .linkedin-icon {
    background-image: url("data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjI0cHgiIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDQzMC4xMTcgNDMwLjExNyIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDMwLjExNyA0MzAuMTE3OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggaWQ9IkxpbmtlZEluIiBkPSJNNDMwLjExNywyNjEuNTQzVjQyMC41NmgtOTIuMTg4VjI3Mi4xOTNjMC0zNy4yNzEtMTMuMzM0LTYyLjcwNy00Ni43MDMtNjIuNzA3ICAgYy0yNS40NzMsMC00MC42MzIsMTcuMTQyLTQ3LjMwMSwzMy43MjRjLTIuNDMyLDUuOTI4LTMuMDU4LDE0LjE3OS0zLjA1OCwyMi40NzdWNDIwLjU2aC05Mi4yMTljMCwwLDEuMjQyLTI1MS4yODUsMC0yNzcuMzJoOTIuMjEgICB2MzkuMzA5Yy0wLjE4NywwLjI5NC0wLjQzLDAuNjExLTAuNjA2LDAuODk2aDAuNjA2di0wLjg5NmMxMi4yNTEtMTguODY5LDM0LjEzLTQ1LjgyNCw4My4xMDItNDUuODI0ICAgQzM4NC42MzMsMTM2LjcyNCw0MzAuMTE3LDE3Ni4zNjEsNDMwLjExNywyNjEuNTQzeiBNNTIuMTgzLDkuNTU4QzIwLjYzNSw5LjU1OCwwLDMwLjI1MSwwLDU3LjQ2MyAgIGMwLDI2LjYxOSwyMC4wMzgsNDcuOTQsNTAuOTU5LDQ3Ljk0aDAuNjE2YzMyLjE1OSwwLDUyLjE1OS0yMS4zMTcsNTIuMTU5LTQ3Ljk0QzEwMy4xMjgsMzAuMjUxLDgzLjczNCw5LjU1OCw1Mi4xODMsOS41NTh6ICAgIE01LjQ3Nyw0MjAuNTZoOTIuMTg0di0yNzcuMzJINS40NzdWNDIwLjU2eiIgZmlsbD0iI0ZGRkZGRiIvPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=")
  }

  .icon {
    display: inline-block;
    height: 2em;
    width: 2em;
    background-repeat: no-repeat;
    background-size: contain;
    vertical-align: text-bottom;
    margin: 0 auto;
  }

  .site-style {
    padding-top: 3%;
    font-weight: bold;
    font-size: 20pt;
    color: #296392;
    margin: 0 auto 3%;
  }

  .button-style {
    background-color: #296392;
    margin-left: 4%;
    margin-right: 4%;
    margin-bottom: 4%;
  }

  .framed {
    margin: 1%;
  }

  .icon:hover {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
</style>



// WEBPACK FOOTER //
// src/components/utilComponents/CreditsModal.vue